import zsSvg from '../../../assets/icons/Zs.svg';

interface NightZsProps {
  className?: string;
}

/**
 * Sleeping Zs graphic for the night cloud mascot.
 * Positioned absolutely relative to the mascot container.
 * Uses percentage-based positioning so it scales with the mascot size
 * (128px on mobile, 160px on sm+).
 *
 * Note: The NightCloudMascot uses viewBox="0 0 160 100" but renders as square (160x160px),
 * causing 1.6x vertical stretch. The Zs positioning is adjusted to align with the
 * stretched nightcap position.
 *
 * Positioning (as percentages of rendered size):
 * - left: 13.84% (22.15px offset from Figma)
 * - top: 13% (adjusted for viewBox stretch)
 * - width: 13.61%
 * - height: 20.70%
 */
export default function NightZs({ className }: NightZsProps) {
  return (
    <img
      src={zsSvg}
      alt=""
      aria-hidden="true"
      className={className}
      style={{
        position: 'absolute',
        width: '13.61%',
        height: '20.70%',
        top: '13%',
        left: '13.84%',
      }}
    />
  );
}
